module.exports = {
    RECEIVE_ALL_ACTIVITY: 'RECEIVE_ALL_ACTIVITY',
    RECEIVE_ACTIVITY: 'RECEIVE_ACTIVITY',
    ACTIVITIES: 'ACTIVITIES',
    RESET_ACTIVITY: 'RESET_ACTIVITY',
}
